import { render, staticRenderFns } from "./Ansprechpartner.vue?vue&type=template&id=44a376ac&scoped=true&"
import script from "./Ansprechpartner.vue?vue&type=script&lang=js&"
export * from "./Ansprechpartner.vue?vue&type=script&lang=js&"
import style0 from "./Ansprechpartner.vue?vue&type=style&index=0&id=44a376ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a376ac",
  null
  
)

export default component.exports